export default {
  authorization: "Genehmigung",
  cancel: "Abbrechen",
  delete: "Löschen",
  healthy: "Gesund",
  warning: "Warnung",
  rating: "Bewertung",
  wear: "Abnutzung",
  architecture: "Architektur",
  submit: "Absenden",
  edited: "Bearbeitet",
  installed: "Installiert",
  create: "Anlegen",
  model: "Modell",
  current: "Aktuell",
  name: "Name",
  version: "Version",
  todos: "Todos",
  type: "Typ",
  loading: "Lädt...",
  asset: "Asset",
  pendingActions: "Anstehende Aktionen",
  noAssetAssigned: "Kein Asset zugewiesen",
  dashboard: "Dashboard",
  details: "Details",
  vulnerabilities: "Schwachstellen",
  installedOn: "Installiert am",
  created: "Erstellt",
  createdBy: "Erstellt von",
  modified: "Geändert",
  released: "Veröffentlicht",
  alerts: "Alerts",
  versions: "Versionen",
  description: "Description",
  noDescription: "Keine Beschreibung",
  confirmationOfOrder: "Auftragsbestätigung",
  feature: "Ausstattungsmerkmal",
  equipment: "Ausrüstung",
  select: "Auswählen",
  administrator: "Administrator",
  digger: "Bagger",
  typeOf: "vom Typ",
  yearOfConstruction: "Baujahr",
  confirm: "Bestätigen",
  edit: "Bearbeiten",
  assignedTo: "Assigned to",
  noAssignment: "Keine Zuordnung",
  event: "Ereignis",
  continue: "Fortsetzen",
  machine: "Gerät",
  media: "Media",
  deliveryNote: "Lieferschein",
  rentalAgreement: "Mietvertrag",
  tenant: "Mandant",
  topSlewingCranes: "Obendreher",
  OK: "OK",
  scheduler: "Planer",
  productArea: "Produktbereich",
  productDivision: "Produktsparte",
  productGroup: "Produktgruppe",
  productLine: "Produktlinie",
  productFamily: "Produktfamilie",
  productModel: "Produktmodell",
  productCategory: "Produktkategorie",
  reset: "Reset",
  wheelLoader: "Radlader",
  invoice: "Rechnung",
  crawler: "Raupenbagger",
  quickChanger: "Schnellwechsler",
  weldingBadge: "Schweißplakette",
  save: "Speichern",
  listOfParts: "Stückliste",
  towerPiece: "Turmstück",
  next: "Weiter",
  previous: "Zurück",
  yes: "Ja",
  no: "Nein",
  back: "Zurück",
  assign: "Zuordnen",
  field: "Feld",
  key: "Schlüssel",
  value: "Wert",
  all: "Alle",
  user: "Benutzer",
  paired: "Verbundende",
  notPaired: "Nicht Verbundende",
  receiver: "Receiver",
  list: "List",
  rest: "Rest",
  interval: "Interval",
  state: "State",
  coupling: "Coupling",
  never: "never",
  optional: "Optional",
  good: "Good",
  critical: "Critical",
  unknown: "Unknown",
  noAsset: "Kein Asset zugewiesen",
  upToDate: "Aktuell",
  pending: "Anstehend",
  filterByRating: "Filter by Rating",
  logs: "Logs",
  search: "Suche",
  tags: "Tags",
  tag: "Tag",
  refresh: "Aktualisieren",
  resetPassword: "Passwort zurücksetzen",
  service: "Service",
  hash: "Hash",
  status: "Status",
};
